module.exports = __webpack_public_path__ + "img/logo.ecb72bf8.png";